/**
 * Playready HTTP Headers.
 *
 *
 * @beta
 */
export const HTTP_HEADERS = 'HttpHeaders'
